import { Box, Grid, Image, ActionIcon, Group } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2'; // Install if not installed: npm i sweetalert2
import ApiLinks from '../Navlinks/ApiLinks';

export default function ImagesGrid({ data, setData, compcode }) {
  if (!data || data.length === 0) {
    return <Box mt="md">No images uploaded yet.</Box>;
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this image?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.PropertyImages_Delete}/${id}/${compcode}`
        );
        if (response.data.status) {
          toast.success('Image deleted');
          setData((prev) => prev.filter((img) => img.id !== id));
        } else {
          toast.error(response.data.message || 'Delete failed');
        }
      } catch (error) {
        console.error('Delete error:', error);
        toast.error('Error deleting image');
      }
    }
  };

  return (
    <Grid gutter="md">
      {data.map((item) => {
        const imageUrl = `${process.env.REACT_APP_IMG_URL}/${item.images}`;

        return (
          <Grid.Col key={item.id} xs={6} sm={4} md={3} lg={2}>
            <Box
              sx={(theme) => ({
                position: 'relative',
                borderRadius: theme.radius.md,
                overflow: 'hidden',
                border: `1px solid ${theme.colors.gray[4]}`,
              })}
            >
              <Image
                src={imageUrl}
                alt="Uploaded"
                width="100%"
                height={150}
                fit="cover"
                withPlaceholder
              />

              {/* Delete Icon */}
              <ActionIcon
                color="red"
                variant="filled"
                size="sm"
                sx={{ position: 'absolute', top: 5, right: 5 }}
                onClick={() => handleDelete(item.id)}
              >
                <IconTrash size={16} />
              </ActionIcon>
            </Box>
          </Grid.Col>
        );
      })}
    </Grid>
  );
}
